import React from 'react';
import { Nav } from 'react-bootstrap';
import { useLocation,useRouteMatch } from 'react-router-dom'

const SubMenu=(props)=>{
    let match = useRouteMatch();
    let location = useLocation();
    
    let abPath = location.pathname.substr(location.pathname.indexOf('/',1));
    let {menus} = props;
    menus.forEach(e=>e.isActive=abPath.indexOf(e.href)===0);
    return (
      <Nav justify  bg="light" className="sub-menu">
          {
            menus.map((e,i)=><Nav.Item
            key={i} 
            >
                <Nav.Link
                  href={`${match.url}${e.href}`} 
                  active={e.isActive}  
                  >{e.title}</Nav.Link>
              </Nav.Item>
              )
          }
      </Nav>
    )
  }
export default SubMenu;